import apiClient from '../axios.js'

/**
 * 平台帳號管理 API
 */
export const platformAccountService = {
    /**
     * 獲取平台帳號列表
     * @param {Object} params - 查詢參數
     * @param {number} params.page - 頁碼
     * @param {number} params.pageSize - 每頁數量
     * @param {string} params.search - 搜尋關鍵字
     * @param {string} params.platformId - 平台 ID（可選）
     * @returns {Promise<Object>} 帳號列表
     */
    getAccounts: async (params = {}) => {
        const response = await apiClient.get('/system/platforms/accounts', { params })
        return response
    },

    /**
     * 獲取單一平台帳號詳情
     * @param {string} id - 帳號 ID
     * @returns {Promise<Object>} 帳號詳情
     */
    getAccount: async (id) => {
        const response = await apiClient.get(`/system/platforms/accounts/${id}`)
        return response
    },

    /**
     * 新增平台帳號
     * @param {Object} accountData - 帳號資料
     * @returns {Promise<Object>} 新增結果
     */
    createAccount: async (accountData) => {
        const response = await apiClient.post('/system/platforms/accounts', accountData)
        return response
    },

    /**
     * 更新平台帳號
     * @param {string} id - 帳號 ID
     * @param {Object} accountData - 帳號資料
     * @returns {Promise<Object>} 更新結果
     */
    updateAccount: async (id, accountData) => {
        const response = await apiClient.put(`/system/platforms/accounts/${id}`, accountData)
        return response
    },

    /**
     * 刪除平台帳號
     * @param {string} id - 帳號 ID
     * @returns {Promise<Object>} 刪除結果
     */
    deleteAccount: async (id) => {
        const response = await apiClient.delete(`/system/platforms/accounts/${id}`)
        return response
    },

    /**
     * 獲取平台帳號 Dashboard 統計資訊
     * @returns {Promise<Object>} 統計資訊（包含客戶數上限和目前客戶數總量）
     */
    getDashboardStats: async () => {
        const response = await apiClient.get('/system/platforms/accounts/dashboard/stats')
        return response
    },
}
